import React from 'react';
import PropTypes from 'prop-types';
import { UserOutlined, CreditCardOutlined } from '@ant-design/icons';
import Logo from '../Logo';
import { Row, Col, Radio } from 'antd';
import { Dialog } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { payManual } from '../../api';
import moment from 'moment';

const InvoiceDialog = ({ open, bill, cards, subscriber, handleClose, token }) => {
    const { errors, control, handleSubmit } = useForm();
    const onSubmit = (value) => {
        payManual({ token, subscription_id: bill?.id, request: value })
            .then((response) => {
                handleClose(false);
                window.location.reload(true);
            })
            .catch((error) => {});
    };
    return (
        <Dialog
            className="invoiceDialogContainer"
            open={open}
            fullWidth={true}
            maxWidth="md"
            onBackdropClick={() => handleClose(false)}
        >
            <div className="dialogHeader">
                <Logo />{' '}
                <h1 className="bigHeader">
                    {' '}
                    {`INVOICE FOR ${moment(bill?.payment_date, 'DD-MM-YYYY').format('MMMM YYYY')}`}
                </h1>
            </div>

            <Row justify="center" className="dialogContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 8 }}
                    xl={{ span: 8 }}
                    xxl={{ span: 8 }}
                >
                    <div className="priceContainer">
                        <h4>Summery</h4>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Month :</label>
                            <span className="horizontal-container-element">
                                {/* {subscription.length > 0 && subscription[0].status} */}
                                {moment(bill?.payment_date, 'DD-MM-YYYY').format('MMMM')}
                            </span>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">From Date :</label>
                            <span className="horizontal-container-element">
                                {/* {subscription.length > 0 && subscription[0].status} */}
                                {bill?.payment_date}
                            </span>
                        </div>
                        {/* <div className="horizontal-container">
                  <label className="horizontal-container-element">T0 Date :</label>
                  <span className="horizontal-container-element">
                    30.01.2020
                  </span>
                </div>
                */}

                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Total Due :</label>
                            <span className="horizontal-container-element dueAmount">{bill?.included_tax}</span>
                        </div>
                        {bill?.payment_status === 'Unpaid' && (
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Controller
                                    name="payment_card_id"
                                    as={
                                        <Radio.Group>
                                            {cards.map((card) => {
                                                return <Radio value={card.id}>{card.number}</Radio>;
                                            })}
                                        </Radio.Group>
                                    }
                                    control={control}
                                    onChange={([event]) => {
                                        return event.target.value;
                                    }}
                                    rules={{ required: true }}
                                />
                                {errors?.payment_card_id && (
                                    <span className="formFieldError">Please select your payment card.</span>
                                )}
                                <input type="submit" className="btnPayNow primary-btn" value="Pay Now" />
                            </form>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 10, offset: 2 }}
                    xl={{ span: 10, offset: 2 }}
                    xxl={{ span: 10, offset: 2 }}
                    className="infoContainer"
                >
                    <section>
                        <div className="current-subscription-label-container">
                            <UserOutlined className="current-subscription-icon" />
                            <h4>Subscriber Information</h4>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Name : </label>
                            <h6 className="horizontal-container-element label-information">
                                {`${subscriber?.subscriber.first_name} ${subscriber?.subscriber.last_name}`}
                            </h6>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Phone : </label>
                            <h6 className="horizontal-container-element label-information">
                                {subscriber?.subscriber?.profile?.contact_number}
                            </h6>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Address : </label>
                            <h6 className="horizontal-container-element label-information">
                                {subscriber?.subscriber?.profile?.address}
                            </h6>
                        </div>
                    </section>
                    <section>
                        <div className="current-subscription-label-container">
                            <CreditCardOutlined className="current-subscription-icon" />
                            <h4>Payment Information</h4>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Card : </label>
                            <h6 className="horizontal-container-element label-information">
                                {subscriber?.payment?.number}
                            </h6>
                        </div>
                        <div className="horizontal-container">
                            <label className="horizontal-container-element">Expiry Date : </label>
                            <h6 className="horizontal-container-element label-information">
                                {subscriber?.payment?.expiry_date}
                            </h6>
                        </div>
                    </section>
                </Col>
            </Row>
        </Dialog>
    );
};

InvoiceDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    bill: PropTypes.object.isRequired,
    subscriber: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
};

InvoiceDialog.defaultProps = {
    open: false,
};
export default InvoiceDialog;
